import { WooCommerceShippingAddress } from '../../core/interfaces/woo-commerce/api/woo-commerce-api.interface';

export function getPickupLocationBackendId(
  address?: WooCommerceShippingAddress | null
): string {
  if (!address) {
    return '';
  }

  return String(address.pickup_location_id || address.id || '');
}
